import * as React from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import AuditTable from "@components/Dashboard/Audittable";
import BreakupBox from "@components/Audit/breakup-box";
import GraphTable from "@components/Dashboard/graph";
// import "./index.scss";
import { getValue } from "@utils/lodash";
import NoAccessPage from "@components/common/NoAccess";
import {
	getDashboardActivity,
	getDashboardCategory,
	getDashboardFunctions,
	getDashboardLocation,
	getDashboardNatureScore,
	getDashboardOverallScore,
	getDashboardState,
	getDashboardStateMonth,
} from "@services/dashboard.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { CheckDecimal } from "@_common/check-decimal";
import { Bar, Line, Doughnut } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	LineElement,
	PointElement,
	ArcElement,
} from "chart.js";
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
	formatDecimal,
	json2array,
	json2arrayKeyAsMonth,
	textCapitalize,
} from "@_common/text-helpers";
import { months, monthsString } from "@_common/month";
import { formatText } from "@_common/format-text";
import InputField from "@_common/InputRuleFeild";
import { adminGetStatesListManagement } from "@services/list-management.service";
import ExpandableTable from "@components/Dashboard/ExpandableTable";
import ComplainceExpandableTable from "../../../components/Dashboard/ComplianceExpandableTable";
import Loader from "@components/common/Loader";
import DashboardSvgComponent from "../../../assets/svg-components/left-menu/dashboard";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	ChartDataLabels,
	LineElement,
	PointElement,
	ArcElement,
	zoomPlugin
);

export default function Compliance(props: any) {
	const navigate = useNavigate();

	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */
	const [isLoading, setIsLoading] = React.useState(true);
	const [isLoading1, setIsLoading1] = React.useState(false);
	const [isLoading2, setIsLoading2] = React.useState(false);
	const [isLoading3, setIsLoading3] = React.useState(false);
	const [natureScoreInfo, setNatureScoreInfo] = React.useState<any>([]);
	const [stateListInfo, setStateListInfo] = React.useState<any>([]);
	const [yearList, setYearList] = React.useState([]);
	const [from_date, setFirstDay] = React.useState(new Date());
	const [to_date, setLastDay] = React.useState(new Date());
	const [year, setYear] = React.useState<any>("2022");

	const random_rgba = () => {
		const colors = [
			"#E8F0FE",
			"#F0F9F6",
			"#FDF9F4",
			"#D8E6FE",
			"#FBF2F4",
			"#FFFCFC",
			"#FDFEFF",
		];
		var random_color: any = colors[Math.floor(Math.random() * colors.length)];
		return random_color;
	};

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	React.useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
			getActivityInfo();
			getOvarallScoreInfo();
			getNatureScoreInfo();
			getStateListInfo();
			getMonthListInfo();
			getLocationInfo();
			getCategoryInfo();
			let dates = params.date ? new Date(params.date) : new Date();
			var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
			var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
			setFirstDay(from_date);
			setLastDay(to_date);
			setYear(params.year ? params.year : new Date().getFullYear());
		}

		let currentYear: any = "2021";
		let count = new Date().getFullYear() + 1;
		let yearList: any = [];
		Array.from({ length: count }, (v, k) => k).map((k) => {
			if (k >= currentYear) {
				return yearList.push({
					value: `${k}`,
					label: `${k}`,
				});
			}
		});
		setYearList(yearList);
		getStatesList(101);
	}, [props.permissionAPITriggered]);

	React.useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
			getActivityInfo();
			getOvarallScoreInfo();
			getNatureScoreInfo();
			getLocationInfo();
			getStateListInfo();
			getMonthListInfo();
			getCategoryInfo();
			if (params.from_date && params.to_date) {
				// setDate(new Date(params.date));
				var from_date = new Date(params.from_date);
				var to_date = new Date(params.to_date);
				setFirstDay(from_date);
				setLastDay(to_date);
			}
			if (params.year) {
				setYear(params.year ? params.year : new Date().getFullYear());
			}
		}
	}, [window.location.href, props.permissionAPITriggered]);

	const [state_loading, setState_loading] = React.useState(false);
	const getStateListInfo = async () => {
		try {
			setState_loading(false);
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			var state_year = params.state_year
				? params.state_year
				: new Date().getFullYear();
			var state_month: any = params.state_month
				? params.state_month
				: new Date().getMonth() + 1;
			let payload = {
				year: state_year,
				month: parseInt(state_month),
				country_id: 101,
			};
			let queryRequest = QueryRequestHelper(payload);
			let resp = await getDashboardState(queryRequest);
			if (resp) {
				let labels: any = [];
				let response = json2array(getValue(resp, `data`, {}));
				labels =
					getValue(response, `length`, 0) > 0 &&
					response.map((item: any) => Object.keys(item));
				let finalLabels = [].concat(...labels);
				let complaince_data: any = [];
				let non_complaince_data: any = [];
				for (let i = 0; i < getValue(response, `length`, 0); i++) {
					complaince_data.push(
						CheckDecimal(
							getValue(response, `[${i}]${labels[i]}.complied.score`, 0)
						)
					);
					non_complaince_data.push(
						CheckDecimal(
							getValue(response, `[${i}]${labels[i]}.non_complied.score`, 0)
						)
					);
				}
				setStateData({
					...stateData,
					labels: getValue(finalLabels, `length`, 0) > 0 ? finalLabels : [],
					datasets: [
						{
							label: "Non-Complied",
							data: non_complaince_data,
							backgroundColor: "#E8F0FE",
							barThickness: 70,
						},
						{
							label: "Complied",
							data: complaince_data,
							backgroundColor: "#72A4F7",
							barThickness: 70,
						},
					],
				});
				setState_loading(false);
			} else {
				setState_loading(false);
			}
		} catch (error) {
			setState_loading(false);
		}
	};
	const [states, setStates] = React.useState([]);
	const getStatesList = async (countryId: number) => {
		try {
			let resp = await adminGetStatesListManagement(countryId);
			if (resp) {
				setStates(
					getValue(resp, `data.states`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const [month_loading, setMonth_loading] = React.useState(false);
	const getMonthListInfo = async () => {
		try {
			setMonth_loading(false);
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			var state_month_year = params.state_month_year
				? params.state_month_year
				: new Date().getFullYear();
			var state_month_state_id: any = params.state_month_state_id
				? params.state_month_state_id
				: "4026";

			let payload = {
				year: state_month_year,
				state_id: state_month_state_id,
			};
			let queryRequest = QueryRequestHelper(payload);
			let resp = await getDashboardStateMonth(queryRequest);
			if (resp) {
				let labels: any = [];
				let response = json2array(getValue(resp, `data`, {}));
				labels = monthsString.filter((item, i) => i !== 0 && item);
				let finalLabels = [].concat(...labels);
				let complaince_data: any = [];
				let non_complaince_data: any = [];
				for (let i = 0; i < getValue(response, `length`, 0); i++) {
					complaince_data.push(
						CheckDecimal(
							getValue(response, `[${i}]${labels[i]}.complied.score`, 0)
						)
					);
					non_complaince_data.push(
						CheckDecimal(
							getValue(response, `[${i}]${labels[i]}.non_complied.score`, 0)
						)
					);
				}
				setMonthStateData({
					...stateData,
					labels: getValue(finalLabels, `length`, 0) > 0 ? finalLabels : [],
					datasets: [
						{
							label: "Non-Complied",
							data: non_complaince_data,
							backgroundColor: "#E8F0FE",
							barThickness: 70,
						},
						{
							label: "Complied",
							data: complaince_data,
							backgroundColor: "#72A4F7",
							barThickness: 70,
						},
					],
				});
				setMonth_loading(false);
			} else {
				setMonth_loading(false);
			}
		} catch (error) {
			setMonth_loading(false);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const [activityList, setActivityList] = React.useState([]);
	const [closedList, setClosedList] = React.useState([]);
	const [openList, setOpenList] = React.useState([]);

	const getActivityInfo = async () => {
		try {
			setIsLoading(true);
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			let dates = params.date ? new Date(params.date) : new Date();
			var from_date = params.from_date
				? params.from_date
				: new Date(dates.getFullYear(), dates.getMonth(), 1);
			var to_date = params.to_date
				? params.to_date
				: new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

			let payload = {
				from_date: moment(from_date).format("YYYY-MM-DD"),
				to_date: moment(to_date).format("YYYY-MM-DD"),
			};
			let queryRequest = QueryRequestHelper(payload);
			let resp = await getDashboardActivity(queryRequest);
			if (resp) {
				let activity = json2array(getValue(resp, `data.activity`, {}));
				let act = activity.map((item: any) => ({
					...item,
					activity: Object.keys(item)[0],
				}));
				let open = json2array(getValue(resp, `data.open`, {}));
				let op = open.map((item: any) => ({
					...item,
					activity: Object.keys(item)[0],
				}));
				let close = json2array(getValue(resp, `data.closed`, {}));
				let cl = close.map((item: any) => ({
					...item,
					activity: Object.keys(item)[0],
				}));
				setActivityList(act);
				setOpenList(op);
				setClosedList(cl);
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};
	const getOvarallScoreInfo = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		try {
			setIsLoading1(true);
			let payload = {
				year: getValue(params, `year`, "")
					? getValue(params, `year`, "")
					: year,
			};
			let queryRequest = QueryRequestHelper(payload);
			let resp = await getDashboardOverallScore(queryRequest);
			if (resp) {
				let labels: any = [];
				labels = monthsString.filter((item, i) => i !== 0 && item);
				let finalLabels = [].concat(...labels);
				let complaince_data: any = [];
				let non_complaince_data: any = [];
				let score: any = [];
				labels.map((_item: any, index: number) => {
					if (getValue(resp, `data[${index}]`, {})) {
						return (
							// complaince_data.push(
							// 	CheckDecimal(getValue(resp, `data[${index}].complied.score`, 0))
							// ),
							// non_complaince_data.push(
							// 	CheckDecimal(
							// 		getValue(resp, `data[${index}].non_complied.score`, 0)
							// 	)
							score.push(
								CheckDecimal(getValue(resp, `data[${index}].score`, 0))
							)
						);
					} else {
						// complaince_data.push(0);
						// non_complaince_data.push(0);
						score.push(0);
					}
				});
				setMonthData({
					...categoryData,
					labels: getValue(finalLabels, `length`, 0) > 0 ? finalLabels : [],
					datasets: [
						{
							label: "Score",
							data: score,
							borderColor: "#05A357",
							barThickness: 70,
						},
						// {
						// 	label: "Non-Complied",
						// 	data: non_complaince_data,
						// 	borderColor: "#D7242E",
						// 	barThickness: 70,
						// },
						// {
						// 	label: "Complied",
						// 	data: complaince_data,
						// 	borderColor: "#05A357",
						// 	barThickness: 70,
						// },
					],
				});
				setIsLoading1(false);
			} else {
				setIsLoading1(false);
			}
		} catch (error) {
			setIsLoading1(false);
		}
	};

	const getNatureScoreInfo = async () => {
		try {
			setIsLoading2(true);
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			let dates = params.date ? new Date(params.date) : new Date();
			var from_date = params.from_date
				? params.from_date
				: new Date(dates.getFullYear(), dates.getMonth(), 1);
			var to_date = params.to_date
				? params.to_date
				: new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

			let payload = {
				from_date: moment(from_date).format("YYYY-MM-DD"),
				to_date: moment(to_date).format("YYYY-MM-DD"),
			};
			let queryRequest = QueryRequestHelper(payload);
			let resp = await getDashboardNatureScore(queryRequest);
			if (resp) {
				// table
				let data = json2array(
					getValue(resp, `data.compliancePercentageByNature`, {})
				);
				let nature = data.map((item: any) => ({
					...item,
					nature: Object.keys(item)[0],
				}));
				setNatureScoreInfo(getValue(nature, `length`, 0) > 0 ? nature : []);

				// // dognut chart
				// let labels: any = [];
				// let response = json2array(getValue(resp, `data`, {}));
				// labels =
				// 	getValue(response, `length`, 0) > 0 &&
				// 	response.map((item: any) => Object.keys(item));
				// let finalLabels = [].concat(...labels);
				// let complaince_data: any = [];
				// let non_complaince_data: any = [];
				// for (let i = 0; i < getValue(response, `length`, 0); i++) {
				// 	complaince_data.push(
				// 		CheckDecimal(
				// 			getValue(response, `[${i}]${labels[i]}.complied_score`, 0)
				// 		)
				// 	);
				// 	non_complaince_data.push(
				// 		CheckDecimal(
				// 			getValue(response, `[${i}]${labels[i]}.non_complied_score`, 0)
				// 		)
				// 	);
				// }

				// const sum1 = complaince_data.reduce(
				// 	(partialSum: any, a: any) => partialSum + a,
				// 	0
				// );
				// const sum2 = non_complaince_data.reduce(
				// 	(partialSum: any, a: any) => partialSum + a,
				// 	0
				// );
				setNatureData({
					...categoryData,
					labels: ["Complied", "Not-Complied"],
					datasets: [
						{
							// label: "Non-Complied",
							// data: [
							// 	sum1 > 0 ? sum1 / getValue(complaince_data, `length`, 1) : 0,
							// 	sum2 > 0
							// 		? sum2 / getValue(non_complaince_data, `length`, 1)
							// 		: 0,
							// ],
							data: [
								formatDecimal(
									getValue(resp, `data.complianceScorePieChart.complied`, "")
								),
								formatDecimal(
									getValue(
										resp,
										`data.complianceScorePieChart.non_complied`,
										""
									)
								),
							],
							backgroundColor: ["#05A357", "#D7242E"],
							barThickness: 70,
						},
					],
				});

				setIsLoading2(false);
			} else {
				setIsLoading2(false);
			}
		} catch (error) {
			setIsLoading2(false);
		}
	};

	const [cat_loading, set_cat_loading] = React.useState(false);
	const getCategoryInfo = async () => {
		try {
			set_cat_loading(true);
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			var cat_year = params.cat_year
				? params.cat_year
				: new Date().getFullYear();
			var cat_month: any = params.cat_month
				? params.cat_month
				: new Date().getMonth() + 1;
			let payload = {
				year: cat_year,
				month: parseInt(cat_month),
			};
			let queryRequest = QueryRequestHelper(payload);
			let resp = await getDashboardCategory(queryRequest);
			if (resp) {
				let labels: any = [];
				let response = json2array(getValue(resp, `data`, {}));
				labels =
					getValue(response, `length`, 0) > 0 &&
					response.map((item: any) => Object.keys(item));
				let finalLabels = [].concat(...labels);
				let complaince_data: any = [];
				let non_complaince_data: any = [];
				for (let i = 0; i < getValue(response, `length`, 0); i++) {
					complaince_data.push(
						CheckDecimal(
							getValue(response, `[${i}]${labels[i]}.complied.score`, 0)
						)
					);
					non_complaince_data.push(
						CheckDecimal(
							getValue(response, `[${i}]${labels[i]}.non_complied.score`, 0)
						)
					);
				}
				setCategoryData({
					...categoryData,
					labels: getValue(finalLabels, `length`, 0) > 0 ? finalLabels : [],
					datasets: [
						{
							label: "Non-Complied",
							data: non_complaince_data,
							backgroundColor: "#E8F0FE",
							barThickness: 70,
						},
						{
							label: "Complied",
							data: complaince_data,
							backgroundColor: "#72A4F7",
							barThickness: 70,
						},
					],
				});
				set_cat_loading(false);
			} else {
				set_cat_loading(false);
			}
		} catch (error) {
			set_cat_loading(false);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                              Date Routes                                   */
	/* -------------------------------------------------------------------------- */
	const handleDate = (date: any) => {
		setFirstDay(date[0]);
		setLastDay(date[1]);
	};
	const handleSubmitDate = () => {
		let first = moment(from_date).format("YYYY-MM-DD");
		let last = moment(to_date).format("YYYY-MM-DD");
		if ((first && last) && (first !== "Invalid date" && last !== "Invalid date")) {
			let payload: any = {
				from_date: first,
				to_date: last,
			};
			if (payload.from_date && payload.to_date) {
				let queryRequest = QueryRequestHelper(payload);
				navigate(`${window.location.pathname}?${queryRequest}`);
			} else {
				toast.error("Start Date and End Date Required");
			}
		} else {
			toast.error("Please select date");
		}
	};
	/* -------------------------------------------------------------------------- */
	/*                                 Chart section                              */
	/* -------------------------------------------------------------------------- */

	const options: any = {
		responsive: true,
		plugins: {
			datalabels: {
				anchor: "start",
				align: "end",
				labels: {
					value: {
						color: "black",
					},
				},
				// formatter: (val: any) => {
				// 	return val + "%";
				// },
			},
			legend: {
				position: "top",
			},
			title: {
				display: false,
				// text: "Chart.js Bar Chart",
			},
			zoom: {
				pan: {
					enabled: true,
					mode: "x",
				},
				zoom: {
					pinch: {
						enabled: true, // Enable pinch zooming
					},
					wheel: {
						enabled: true, // Enable wheel zooming
					},
					mode: "x",
				},
			},
		},
	};
	const lineOptions: any = {
		responsive: true,
		plugins: {
			legend: {
				position: "top" as const,
			},
			datalabels: {
				anchor: "start",
				align: "end",
				labels: {
					value: {
						color: "black",
					},
				},
				formatter: (val: any) => {
					return val + "%";
				},
			},
			title: {
				display: false,
				// text: "Chart.js Line Chart",
			},
		},
	};
	const [data, setData] = React.useState<any>({
		labels: [],
		datasets: [
			{
				label: "Location 1",
				data: [0, 0],
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				barThickness: 10,
			},
			{
				label: "Location 2",
				data: [0, 0],
				backgroundColor: "rgba(53, 162, 235, 0.5)",
				barThickness: 10,
			},
		],
	});
	const [stateData, setStateData] = React.useState<any>({
		labels: [],
		datasets: [
			{
				label: "State 1",
				data: [0, 0],
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				barThickness: 10,
			},
			{
				label: "State 2",
				data: [0, 0],
				backgroundColor: "rgba(53, 162, 235, 0.5)",
				barThickness: 10,
			},
		],
	});
	const [monthStateData, setMonthStateData] = React.useState<any>({
		labels: [],
		datasets: [
			{
				label: "Month 1",
				data: [0, 0],
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				barThickness: 10,
			},
			{
				label: "Month 2",
				data: [0, 0],
				backgroundColor: "rgba(53, 162, 235, 0.5)",
				barThickness: 10,
			},
		],
	});

	const [categoryData, setCategoryData] = React.useState<any>({
		labels: [],
		datasets: [
			{
				label: "Category 1",
				data: [0, 0],
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				barThickness: 10,
			},
			{
				label: "Category 2",
				data: [0, 0],
				backgroundColor: "rgba(53, 162, 235, 0.5)",
				barThickness: 10,
			},
		],
	});

	const [monthData, setMonthData] = React.useState<any>({
		labels: ["jan"],
		datasets: [
			{
				label: "Jan",
				data: [0, 0],
				fill: false,
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				barThickness: 10,
			},
			{
				label: "Feb",
				data: [0, 0],
				fill: false,
				backgroundColor: "rgba(53, 162, 235, 0.5)",
			},
		],
	});

	const [natureData, setNatureData] = React.useState<any>({
		labels: ["jan"],
		datasets: [
			{
				label: "Jan",
				data: [0, 0],
				fill: false,
				backgroundColor: "rgba(255, 99, 132, 0.5)",
				barThickness: 10,
			},
			{
				label: "Feb",
				data: [0, 0],
				fill: false,
				backgroundColor: "rgba(53, 162, 235, 0.5)",
			},
		],
		borderWidth: 0,
		weight: 1,
	});

	const option: any = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			datalabels: {
				anchor: "start",
				align: "end",
				labels: {
					value: {
						color: "white",
					},
				},
				formatter: (val: any) => {
					return val + "%";
				},
			},
			legend: {
				position: "top",
			},
		},
	};

	const handleChangeYear = (e: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		setYear(e);
		let payload: any = {
			...params,
			year: e,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	// category wise compliance chart
	const handleChangeCatogoryDate = (e: string, value: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		if (value === "year") {
			let payload: any = {
				...params,
				cat_year: e,
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		} else {
			let payload: any = {
				...params,
				cat_month: e,
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		}
	};
	// State wise compliance chart
	const handleChangeStateDate = (e: string, value: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		if (value === "year") {
			let payload: any = {
				...params,
				state_year: e,
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		} else {
			let payload: any = {
				...params,
				state_month: e,
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		}
	};
	// month wise compliance chart
	const handleChangeMonthStateDate = (e: string, value: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		if (value === "year") {
			let payload: any = {
				...params,
				state_month_year: e,
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		} else {
			let payload: any = {
				...params,
				state_month_state_id: e,
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		}
	};
	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());

	// location wise compliance
	const [complianceLocations, setComplianceLocations] = React.useState([]);
	const [functions, setFunctions] = React.useState([]);
	const getLocationInfo = async () => {
		try {
			setIsLoading3(true);
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			let dates = params.date ? new Date(params.date) : new Date();
			var from_date = params.from_date
				? params.from_date
				: new Date(dates.getFullYear(), dates.getMonth(), 1);
			var to_date = params.to_date
				? params.to_date
				: new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

			let payload = {
				from_date: moment(from_date).format("YYYY-MM-DD"),
				to_date: moment(to_date).format("YYYY-MM-DD"),
			};
			let queryRequest = QueryRequestHelper(payload);
			let resp = await getDashboardLocation(queryRequest);
			if (resp) {
				let response = json2array(getValue(resp, `data`, []));
				setComplianceLocations(
					getValue(response, `length`, 0) > 0 &&
						response.map((item: any) => ({
							// console.log(Object.entries(item))
							id: item[Object.entries(item)[0][0]].location_id,
							location: Object.keys(item)[0].split("::")[0],
							auditData: item[Object.entries(item)[0][0]],
						}))
				);
				setIsLoading3(false);
			} else {
				setIsLoading3(false);
			}
		} catch (error) {
			setIsLoading3(false);
		}
	};

	const [child_loading, setChild_loading] = React.useState(false);
	const getLocationFunctions = async (id: string) => {
		if (id) {
			try {
				setChild_loading(true);
				const urlSearchParams = new URLSearchParams(window.location.search);
				const params = Object.fromEntries(urlSearchParams.entries());
				let dates = params.date ? new Date(params.date) : new Date();
				var from_date = params.from_date
					? params.from_date
					: new Date(dates.getFullYear(), dates.getMonth(), 1);
				var to_date = params.to_date
					? params.to_date
					: new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

				let payload = {
					from_date: moment(from_date).format("YYYY-MM-DD"),
					to_date: moment(to_date).format("YYYY-MM-DD"),
					location_id: id,
				};
				let queryRequest = QueryRequestHelper(payload);
				let resp = await getDashboardFunctions(queryRequest);
				if (resp) {
					let response = json2array(getValue(resp, `data`, []));
					setFunctions(
						getValue(response, `length`, 0) > 0 &&
							response.map((item: any) => ({
								// console.log(Object.entries(item))
								id: item[Object.entries(item)[0][0]].function_id,
								location: Object.keys(item)[0].split("::")[0],
								auditData: item[Object.entries(item)[0][0]],
							}))
					);
					setChild_loading(false);
				} else {
					setFunctions([]);
					setChild_loading(false);
				}
			} catch (error) {
				setFunctions([]);
				setChild_loading(false);
			}
		} else {
		}
	};

	const handleNavigateCompliance = (
		complianceId: string,
		type: string,
		value: String
	) => {
		// let compliance_task_ids =
		// 	getValue(compliance_task_id, `length`, 0) > 0 ? compliance_task_id : [];
		var firstDay = params.from_date
			? params.from_date
			: new Date(new Date().getFullYear(), new Date().getMonth(), 1);
		var lastDay = params.to_date
			? params.to_date
			: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

		let payload = {
			// compliance_task_ids: compliance_task_ids,
			request_from: "dashboard",
			request_type: type,
			request_value: value,
			firstDay: moment(firstDay).format("YYYY-MM-DD"),
			lastDay: moment(lastDay).format("YYYY-MM-DD"),
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`/activities/task/compliance/list/${complianceId}?${queryRequest}`);
	};
	return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "dashboard_compliance"
      ) ? (
        <NoAccessPage />
      ) : isLoading || !props.permissionAPITriggered ? (
        <Loader />
      ) : (
        <>
          {/* <div className="dashboard-wrapper__header">
            <h4 className="dashbaord-wrapper__header-title">PE Compliance</h4>
          </div> */}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <DashboardSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Dashboard
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
					PE Compliance
                </h4>
              </div>
            </div>
          </div>

		  <div className={`main-page-layout-wrapper main-page-layout-wrapper-dashboard`}>
			<div className="overview-wrapper pt-1">
				<div className="dashboard-compliance">
				<div className="dashboard-compliance__common d-flex align-items-center justify-content-between mb-3 mt-0">
					<h3 className="dashboard-compliance__title">Activity</h3>
					<h3 className="dashboard-compliance__date dashboard-compliance__date--compliance overview-wrapper__header-date d-flex align-items-center">
					{/* Jan 22, 2021 - Jan 22, 2022
										<img src="/images/arrow-drop.svg" className="img-fluid" /> */}
					<div className="filter-form-wrappper__container d-flex align-items-center">
						


						<RightMenuHeaders
											//   mappedTaskSCExecutor={false}
											  // date range
											  dateRange={true}
											  from_date={from_date}
											  to_date={to_date}
											  handleDate={handleDate}
											  handleSubmitDate={handleSubmitDate}
											  // use license-style separate day pickers
											  licenseStyleCalendar={true}
											  //search
											//   isSearch={true}
						
						
											/>
					{/* <div className="no-bordered-input-calendar mr-2">
						<DatePicker
						selectsRange={false}
						selected={from_date ? new Date(from_date) : null}
						className="react-date-picker__inputGroup__input"
						onChange={(date: any) => {
							if (date && to_date && new Date(date) > new Date(to_date)) {
							toast.error("From Date cannot be greater than To Date");
							} else {
							handleDate([date, to_date]);
							}
						}}
						dateFormat="d MMM yyyy"
						showMonthDropdown
						showYearDropdown
						dropdownMode="select"
						placeholderText="Select From Date"
						maxDate={to_date ? new Date(to_date) : undefined}
						/>
					</div> */}
					{/* <div className="no-bordered-input-calendar mr-2">
						<DatePicker
						selectsRange={false}
						selected={to_date ? new Date(to_date) : null}
						className="react-date-picker__inputGroup__input"
						onChange={(date: any) => {
							if (from_date && date && new Date(from_date) > new Date(date)) {
							toast.error("To Date cannot be less than From Date");
							} else {
							handleDate([from_date, date]);
							}
						}}
						dateFormat="d MMM yyyy"
						showMonthDropdown
						showYearDropdown
						dropdownMode="select"
						placeholderText="Select To Date"
						minDate={from_date ? new Date(from_date) : undefined}
						/>
					</div> */}
					{/* <button
						className="dashboard-wrapper__apply-btn ml-2"
						onClick={handleSubmitDate}
					>
						Apply
					</button> */}
					</div>
					</h3>
				</div>
				<div className="d-flex align-items-center box-gap mb-3">
					{activityList.map((obj: any, index) => {
					if (
						getValue(obj, `[${getValue(obj, `activity`, "")}].count`, 0)
					)
						return (
						<section
							key={index}
							className={`breakup-box breakup-box--${obj.color} breakup-box--${obj.background}`}
							style={{ backgroundColor: random_rgba() }}
							onClick={() =>
							getValue(
								obj,
								`[${getValue(obj, `activity`, "")}].count`,
								0
							) > 0 &&
							handleNavigateCompliance(
								getValue(
								obj,
								`[${getValue(
									obj,
									`activity`,
									""
								)}].compliance_type_id`,
								""
								),
								"activity",
								getValue(obj, `activity`, "")
							)
							}
						>
							<div className="breakup-box__details">
							<h6
								className={`breakup-box__title breakup-box__title--${obj.color}`}
							>
								{getValue(
								obj,
								`[${getValue(obj, `activity`, "")}].count`,
								""
								)}
							</h6>
							<p
								className={`breakup-box__text breakup-box__text--${obj.color}`}
							>
								{textCapitalize(
								formatText(getValue(obj, `activity`, ""))
								)}
							</p>
							</div>
							<img
							src={obj.image}
							className="img-fluid breakup-box-image"
							/>
						</section>
						);
					})}
				</div>
				</div>
				<div className="dashboard-compliance">
				<div className="dashboard-compliance__common d-flex align-items-center justify-content-between">
					<h3 className="dashboard-compliance__title">Open</h3>
				</div>
				<div className="dashboard-compliance__closed d-flex align-items-center box-gap mb-3">
					{openList.map((obj: any, index) => {
					// if(getValue(
					// 	obj,
					// 	`[${getValue(obj, `activity`, "")}].count`,
					// 	""
					// )> 0)
					return (
						<section
						className={`breakup-box breakup-box--${obj.color} breakup-box--${obj.background}`}
						style={{ backgroundColor: random_rgba() }}
						onClick={() =>
							getValue(
							obj,
							`[${getValue(obj, `activity`, "")}].count`,
							0
							) > 0 &&
							handleNavigateCompliance(
							"id",
							"open",
							getValue(obj, `activity`, "")
							)
						}
						>
						<div className="breakup-box__details">
							<h6
							className={`breakup-box__title breakup-box__title--${obj.color}`}
							>
							{getValue(
								obj,
								`[${getValue(obj, `activity`, "")}].count`,
								""
							)}
							</h6>
							<p
							className={`breakup-box__text breakup-box__text--${obj.color}`}
							>
							{textCapitalize(
								formatText(getValue(obj, `activity`, ""))
							)}
							</p>
						</div>
						<img
							src={obj.image}
							className="img-fluid breakup-box-image"
						/>
						</section>
					);
					})}
				</div>
				</div>
				<div className="dashboard-compliance w-100">
				<div className="dashboard-compliance__common d-flex align-items-center justify-content-between">
					<h3 className="dashboard-compliance__title">Closed</h3>
				</div>
				</div>
				<div className="dashboard-compliance__closed d-flex align-items-center box-gap mb-3">
				{closedList.map((obj: any, index) => {
					// if(getValue(
					// 	obj,
					// 	`[${getValue(obj, `activity`, "")}].count`,
					// 	0
					// ) > 0)
					return (
					<section
						className={`breakup-box breakup-box--${obj.color} breakup-box--${obj.background}`}
						style={{ backgroundColor: random_rgba() }}
						onClick={() =>
						getValue(
							obj,
							`[${getValue(obj, `activity`, "")}].count`,
							0
						) > 0 &&
						handleNavigateCompliance(
							"id",
							"closed",
							getValue(obj, `activity`, "")
						)
						}
					>
						<div className="breakup-box__details">
						<h6
							className={`breakup-box__title breakup-box__title--${obj.color}`}
						>
							{getValue(
							obj,
							`[${getValue(obj, `activity`, "")}].count`,
							""
							)}
						</h6>
						<p
							className={`breakup-box__text breakup-box__text--${obj.color}`}
						>
							{textCapitalize(
							formatText(getValue(obj, `activity`, ""))
							)}
						</p>
						</div>
						<img
						src={obj.image}
						className="img-fluid breakup-box-image"
						/>
					</section>
					);
				})}
				</div>

				<div className="w-100">
				<div className="loaction-wise-wrapper">
					<div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
					<h3 className="overview-wrapper__header-title">
						Overall Compliance Monthly Score Trend
					</h3>
					</div>
					<div className="vendor-graph">
					<Line data={monthData} options={lineOptions} height={70} />
					</div>
					<div className="overview-wrapper__header vendor-graph-border p-3 m-0 rounded-bottom">
					<div className="filter-form-wrappper__container d-flex">
						<div className="filter-form-wrappper__location-form-group form-group mb-0">
						<div className="grid">
							<div className="input-grid-item mt-0 dd-small-width-year">
							<label
								htmlFor="State"
								className="filter-form-wrappper__label d-none"
							>
								Year
							</label>
							<div className="filter-form-wrappper__location-input">
								<InputField
								inputType="INPUT_REACT_SELECT_MODAL"
								placeholder="Choose Year"
								className="form-control w-100"
								name="state_id"
								id="state_id"
								options={yearList}
								value={yearList.filter(
									(item: any) =>
									getValue(item, `value`, "") == year
								)}
								onChange={(e: any) =>
									handleChangeYear(getValue(e, `value`, ""))
								}
								isClear
								/>
							</div>
							</div>
						</div>
						</div>
					</div>
					</div>
				</div>
				</div>
				<div className="dashboard-compliance__table d-flex">
				<div className="w-100">
					<div className="loaction-wise-wrapper">
					<div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
						<h3 className="overview-wrapper__header-title">
						Overall Compliance Score
						</h3>
						<div className="loaction-wise-list">
						<ul className="d-flex align-items-center">
							<li className="loaction-wise-list-item">
							Non-Compliant
							</li>
							<li className="loaction-wise-list-item">Compliant</li>
						</ul>
						</div>
					</div>
					<div className="vendor-graph">
						<Doughnut data={natureData} options={option} />
					</div>
					</div>
				</div>
				</div>
				<AuditTable tableData={natureScoreInfo} />
				<div className="w-100">
				<div className="loaction-wise-wrapper">
					<div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
					<h3 className="overview-wrapper__header-title">
						State Wise Compliance Status
					</h3>
					<div className="loaction-wise-list">
						<ul className="d-flex align-items-center">
						<li className="loaction-wise-list-item">Non-Compliant</li>
						<li className="loaction-wise-list-item">Compliant</li>
						</ul>
					</div>
					</div>
					<div className="vendor-graph">
					<Bar options={options} data={stateData} height={70} />
					</div>
					<p className="text-center">
					{state_loading ? "Please wait..." : ""}
					</p>
					<div className="overview-wrapper__header vendor-graph-border p-3 m-0 rounded-bottom">
					<div className="filter-form-wrappper__container d-flex">
						<div className="filter-form-wrappper__location-form-group form-group mb-0">
						<div className="grid">
							<div className="input-grid-item mt-0 dd-small-width-year">
							<label
								htmlFor="State"
								className="filter-form-wrappper__label d-none"
							>
								Year
							</label>
							<div className="filter-form-wrappper__location-input">
								<InputField
								inputType="INPUT_REACT_SELECT_MODAL"
								placeholder="Choose Year"
								className="form-control w-100"
								name="state_id"
								id="state_id"
								options={yearList}
								value={yearList.filter(
									(item: any) =>
									getValue(item, `value`, "") ==
									(getValue(params, `state_year`, "")
										? getValue(params, `state_year`, "")
										: new Date().getFullYear())
								)}
								onChange={(e: any) =>
									handleChangeStateDate(
									getValue(e, `value`, ""),
									"year"
									)
								}
								isClear
								menuIsOpen={true}
								/>
							</div>
							</div>
							&nbsp;&nbsp;&nbsp;
							<div className="input-grid-item mt-0 dd-small-width-month">
							<div className="filter-form-wrappper__location-form-group form-group mb-0">
								<label
								htmlFor="State"
								className="filter-form-wrappper__label d-none"
								>
								Month
								</label>
								<div className="filter-form-wrappper__location-input">
								<InputField
									inputType="INPUT_REACT_SELECT_MODAL"
									placeholder="Choose Year"
									className="form-control w-100"
									name="state_id"
									id="state_id"
									options={months}
									value={months.filter(
									(item: any) =>
										getValue(item, `value`, "") ==
										(getValue(params, `state_month`, "")
										? getValue(params, `state_month`, "")
										: new Date().getMonth() + 1)
									)}
									onChange={(e: any) =>
									handleChangeStateDate(
										getValue(e, `value`, ""),
										"month"
									)
									}
									isClear
								/>
								</div>
							</div>
							</div>
						</div>
						</div>
					</div>
					</div>
				</div>
				</div>

				<div className="w-100">
				<div className="loaction-wise-wrapper">
					<div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
					<h3 className="overview-wrapper__header-title">
						Month Wise Compliance Status
					</h3>
					<div className="loaction-wise-list">
						<ul className="d-flex align-items-center">
						<li className="loaction-wise-list-item">Non-Compliant</li>
						<li className="loaction-wise-list-item">Compliant</li>
						</ul>
					</div>
					</div>
					<div className="vendor-graph">
					<Bar options={options} data={monthStateData} height={70} />
					</div>
					<p className="text-center">
					{month_loading ? "Please wait..." : ""}
					</p>
					<div className="overview-wrapper__header vendor-graph-border p-3 m-0 rounded-bottom">
					<div className="filter-form-wrappper__container d-flex">
						<div className="filter-form-wrappper__location-form-group form-group mb-0">
						<div className="grid">
							<div className="input-grid-item mt-0 dd-small-width-year">
							<label
								htmlFor="State"
								className="filter-form-wrappper__label d-none"
							>
								Year
							</label>
							<div className="filter-form-wrappper__location-input">
								<InputField
								inputType="INPUT_REACT_SELECT_MODAL"
								placeholder="Choose Year"
								className="form-control w-100"
								name="state_id"
								id="state_id"
								options={yearList}
								value={yearList.filter(
									(item: any) =>
									getValue(item, `value`, "") ==
									(getValue(params, `state_month_year`, "")
										? getValue(params, `state_month_year`, "")
										: new Date().getFullYear())
								)}
								onChange={(e: any) =>
									handleChangeMonthStateDate(
									getValue(e, `value`, ""),
									"year"
									)
								}
								isClear
								/>
							</div>
							</div>
							&nbsp;&nbsp;&nbsp;
							<div className="input-grid-item mt-0">
							<div className="filter-form-wrappper__location-form-group form-group mb-0">
								<label
								htmlFor="State"
								className="filter-form-wrappper__label d-none"
								>
								States
								</label>
								<div className="filter-form-wrappper__location-input">
								<InputField
									inputType="INPUT_REACT_SELECT_MODAL"
									placeholder="Choose State"
									className="form-control w-100"
									name="state_id"
									id="state_id"
									options={states}
									value={states.filter(
									(item: any) =>
										getValue(item, `id`, "") ==
										(getValue(
										params,
										`state_month_state_id`,
										""
										)
										? getValue(
											params,
											`state_month_state_id`,
											""
											)
										: "4026")
									)}
									onChange={(e: any) =>
									handleChangeMonthStateDate(
										getValue(e, `id`, ""),
										"state_month_state_id"
									)
									}
									isClear
								/>
								</div>
							</div>
							</div>
						</div>
						</div>
					</div>
					</div>
				</div>
				</div>

				<div className="w-100">
				<div className="loaction-wise-wrapper">
					<div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
					<h3 className="overview-wrapper__header-title">
						Category Wise Compliance Status
					</h3>
					<div className="loaction-wise-list">
						<ul className="d-flex align-items-center">
						<li className="loaction-wise-list-item">Non-Compliant</li>
						<li className="loaction-wise-list-item">Compliant</li>
						</ul>
					</div>
					</div>
					<div className="vendor-graph">
					<Bar options={options} data={categoryData} height={70} />
					</div>
					<p className="text-center">
					{cat_loading ? "Please wait..." : ""}
					</p>
					<div className="overview-wrapper__header vendor-graph-border p-3 m-0 rounded-bottom">
					<div className="filter-form-wrappper__container d-flex">
						<div className="filter-form-wrappper__location-form-group form-group mb-0">
						<div className="grid">
							<div className="input-grid-item mt-0 dd-small-width-year">
							<label
								htmlFor="State"
								className="filter-form-wrappper__label d-none"
							>
								Year
							</label>
							<div className="filter-form-wrappper__location-input">
								<InputField
								inputType="INPUT_REACT_SELECT_MODAL"
								placeholder="Choose Year"
								className="form-control w-100"
								name="state_id"
								id="state_id"
								options={yearList}
								value={yearList.filter(
									(item: any) =>
									getValue(item, `value`, "") ==
									(getValue(params, `cat_year`, "")
										? getValue(params, `cat_year`, "")
										: new Date().getFullYear())
								)}
								onChange={(e: any) =>
									handleChangeCatogoryDate(
									getValue(e, `value`, ""),
									"year"
									)
								}
								isClear
								/>
							</div>
							</div>
							&nbsp;&nbsp;&nbsp;
							<div className="input-grid-item mt-0 dd-small-width-month">
							<div className="filter-form-wrappper__location-form-group form-group mb-0">
								<label
								htmlFor="State"
								className="filter-form-wrappper__label d-none"
								>
								Month
								</label>
								<div className="filter-form-wrappper__location-input">
								<InputField
									inputType="INPUT_REACT_SELECT_MODAL"
									placeholder="Choose Month"
									className="form-control w-100"
									name="state_id"
									id="state_id"
									options={months}
									value={months.filter(
									(item: any) =>
										getValue(item, `value`, "") ==
										(getValue(params, `cat_month`, "")
										? getValue(params, `cat_month`, "")
										: new Date().getMonth() + 1)
									)}
									onChange={(e: any) =>
									handleChangeCatogoryDate(
										getValue(e, `value`, ""),
										"month"
									)
									}
									isClear
								/>
								</div>
							</div>
							</div>
						</div>
						</div>
					</div>
					</div>
				</div>
				</div>

				<div className="w-100">
				<div className="loaction-wise-wrapper">
					<div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
					<h3 className="overview-wrapper__header-title">
						Location Wise Audit Uploaded
					</h3>
					</div>
					<ComplainceExpandableTable
					locations={complianceLocations}
					handleClickRow={getLocationFunctions}
					functions={functions}
					child_loading={child_loading}
					headers={[
						"Location",
						"Complied",
						"Not Complied",
						"Not Applicable",
						"Partially Complied",
						"Score",
					]}
					/>
				</div>
				</div>
			</div>
		  </div>

          {/* <div className="text-right">
            <img src="/images/profile-illustration.svg" className="img-fluid" />
          </div> */}
        </>
      )}
    </DashboardLayout>
  );
}
